/* Écran de choix connexion / commande invité — test A/B « login choice » */

class CartLoginChoice extends HTMLElement {
  connectedCallback() {
    this.cartPanel = this.querySelector('[data-panel="cart"]');
    this.choicePanel = this.querySelector('[data-panel="choice"]');
    // titleEl, pas title : HTMLElement.title est l'infobulle et coercerait l'élément en chaîne.
    this.titleEl = this.querySelector('[data-login-choice-title]');

    if (!this.cartPanel || !this.choicePanel) return;

    this.querySelector('[data-login-choice-open]')?.addEventListener('click', (event) => {
      event.preventDefault();
      this.open();
    });

    this.querySelector('[data-login-choice-back]')?.addEventListener('click', () => {
      this.close();
    });

    this.querySelector('[data-login-choice-login]')?.addEventListener('click', () => {
      this.track('login_choice_login');
    });

    this.querySelector('[data-login-choice-guest]')?.addEventListener('click', () => {
      this.track('login_choice_guest');
    });
  }

  /** Éléments voisins masqués pendant l'affichage du choix : contenu du tiroir, ou note de commande sur la page. */
  get neighbours() {
    const selector = this.dataset.hides;
    if (!selector) return [];
    const root = this.closest('cart-drawer') || this.closest('form');
    return root ? root.querySelectorAll(selector) : [];
  }

  /** Le tiroir, quand l'écran de choix y est rendu. Null sur la page panier. */
  get drawer() {
    return this.closest('cart-drawer');
  }

  get payload() {
    const points = this.querySelector('[data-login-choice-points]')?.dataset.loginChoicePoints;

    return {
      surface: this.dataset.context || 'unknown',
      cart_value: Number(this.dataset.cartValue || 0),
      points: Number(points || 0),
      currency: this.dataset.currency || 'EUR'
    };
  }

  track(eventName) {
    window.Shopify?.analytics?.publish(eventName, this.payload);
  }

  /** Éléments qui s'effacent quand l'écran de choix arrive. */
  get leaving() {
    return [this.cartPanel, ...this.neighbours];
  }

  get reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  _fadeOut(elements) {
    elements.forEach((el) => {
      el.classList.add('login-choice-fade', 'is-out');
    });
  }

  /** Rend l'élément puis le fait apparaître en fondu. */
  _reveal(el) {
    el.hidden = false;
    el.classList.add('login-choice-fade', 'is-out');
    void el.offsetWidth; // force le calcul du style de départ, sans dépendre de requestAnimationFrame
    el.classList.remove('is-out');
  }

  /** Exécute la suite une fois le fondu terminé — immédiatement si l'utilisateur refuse les animations. */
  _afterFade(callback) {
    window.clearTimeout(this._fadeTimer);
    this._fadeTimer = window.setTimeout(callback, this.reducedMotion ? 0 : 160);
  }

  open() {
    this._fadeOut(this.leaving);

    this._afterFade(() => {
      this.leaving.forEach((el) => { el.hidden = true; });
      this.drawer?.classList.add('login-choice-open');
      this._reveal(this.choicePanel);
      this.titleEl?.focus();
    });

    this.track('login_choice_shown');
  }

  close() {
    this._fadeOut([this.choicePanel]);

    this._afterFade(() => {
      this.choicePanel.hidden = true;
      this.drawer?.classList.remove('login-choice-open');
      this.leaving.forEach((el) => this._reveal(el));
    });
  }
}

if (!window.customElements.get('cart-login-choice')) {
  window.customElements.define('cart-login-choice', CartLoginChoice);
}
